module.exports = "/assets/0875796e6162054e315b0d521088775f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RC.png
// module id = 1782
// module chunks = 0